import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { toast } from 'react-toastify';
import { useState } from 'react';

function Manage_Cohort_Major_Modal({ isOpen, setIsAdd, addData, id, editData, token, name, setName, maxMainCourse, setMaxMainCourse, maxAlternativeCourse, setMaxAlternativeCourse }) {
  const [loading, setLoading] = useState(false);

  //#region functions
  // set name filed
  const handleNameChange = (e) => setName(e.target.value)
  // set maxMainCourse filed
  const handleMaxMainCourseChange = (e) => setMaxMainCourse(e.target.value)
  // set maxAlternativeCourse filed
  const handlemaxAlternativeCourseChange = (e) => setMaxAlternativeCourse(e.target.value)
  // form submit
  const onSubmit = async () => {

    if (loading) return;
    setLoading(true)

    // payload to backend
    // console.
    const payload = {
      name: name,
      maxMainCourse: Number(maxMainCourse),
      maxAlternativeCourse: Number(maxAlternativeCourse),
    }
    let result

    try {
      // check and validation for name existence
      if (name == '') {
        toast.error('Failed, name is empty!')
        return
      }
      // if id exists it means we add data else edit data
      if (id == -1)
        result = await addData(payload, token)
      else
        result = await editData(payload, id, token)
      // success toast appear if we succeed
      if (result?.status == 200 || result?.status == 201) {
        let msg = id == -1 ? 'Data added successfully' : 'Data edited successfully'
        toast.success(msg)
        // disappear modal
        setIsAdd(false)
      }
    } catch (error) {
      const errmsg = error.response?.data?.message
      if (!errmsg)
        return

      // show error reason as an error toast 
      if (Array.isArray(errmsg)) {

        errmsg.forEach((element, index) => {
          setTimeout(function () {
            toast.error(element)
          }, 200 * index);
        });
      } else {
        toast.error(errmsg)
      }

    } finally {
      setLoading(false)
    }
  }
  //#endregion functions

  //#region render
  return (
    <Modal
      show={isOpen}
      // setIsAdd={setIsAdd}
      onHide={
        function () { setIsAdd(false) }
      }
      centered
    >
      <Modal.Header closeButton  >
        <Modal.Title>{id == -1 ? 'Add new data' : 'Edit data'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group onSubmit={onSubmit} >
          <Form.Label>Name: </Form.Label>
          <Form.Control type="text" onChange={handleNameChange} value={name} placeholder="Enter name.." />
          <br />
          <Form.Label>Max main courses: </Form.Label>
          <Form.Control type="text" onChange={handleMaxMainCourseChange} value={maxMainCourse} placeholder="Enter the number of max main courses.." />
          <br />
          <Form.Label>Max alternative courses: </Form.Label>
          <Form.Control type="text" onChange={handlemaxAlternativeCourseChange} value={maxAlternativeCourse} placeholder="Enter the number of max alternative courses.." />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={loading} variant="primary" type="submit" onClick={() => {
          // this.props.isOpen = false;
          // return handleSubmit(name)
          // return;
          onSubmit()
        }}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  )
  //#endregion render
}

export default Manage_Cohort_Major_Modal;